// ── Mode Profiles (Presets) ──
// Predefined capability configuration sets for different deployment modes.

import type { ModeProfile, BehaviorMode } from "./types";

function on(mode: BehaviorMode = "active"): { enabled: true; behaviorMode: BehaviorMode } {
  return { enabled: true, behaviorMode: mode };
}
function off(): { enabled: false; behaviorMode: BehaviorMode } {
  return { enabled: false, behaviorMode: "hidden" };
}

export const MODE_PROFILES: ModeProfile[] = [
  {
    id: "internal",
    label: "Internal Mode",
    description: "Full access to all capabilities including internal tools. For Koredor team only.",
    overrides: {
      "admin.friction_log": on("active"),
      "admin.system_audit": on("active"),
      "admin.control_plane": on("active"),
      "finance.fie": on("active"),
      "scheduling.intelligence": on("active"),
      "intelligence.dashboard": on("active"),
      "intelligence.automations": on("active"),
    },
  },
  {
    id: "ccc",
    label: "CCC Mode",
    description: "Current Koredor business operations. All production-ready features enabled.",
    overrides: {
      "admin.friction_log": off(),
      "admin.system_audit": on("internal_only"),
      "admin.control_plane": off(),
    },
  },
  {
    id: "contractor_lite",
    label: "Contractor Lite",
    description: "Stripped-down mode for contractor-only clients. CRM, quoting, and advanced intelligence disabled.",
    overrides: {
      "crm.pipeline": off(),
      "crm.intake_review": off(),
      "crm.lead_integrity": off(),
      "crm.follow_up": off(),
      "crm.lead_sources": off(),
      "sales.opportunities": off(),
      "sales.offerings": off(),
      "finance.fie": off(),
      "intelligence.dashboard": off(),
      "intelligence.automations": off(),
      "scheduling.intelligence": off(),
      "reporting.marketing": off(),
      "reporting.disposition": off(),
      "admin.friction_log": off(),
      "admin.system_audit": off(),
      "admin.control_plane": off(),
    },
  },
  {
    id: "enterprise",
    label: "Enterprise",
    description: "Full-featured enterprise deployment with all tiers unlocked.",
    overrides: {
      "finance.fie": on("active"),
      "scheduling.intelligence": on("active"),
      "intelligence.dashboard": on("active"),
      "intelligence.automations": on("active"),
      "materials.product_registry": on("active"),
      "admin.friction_log": off(),
      "admin.system_audit": on("read_only"),
      "admin.control_plane": off(),
    },
  },
  {
    id: "pilot",
    label: "Pilot Client",
    description: "Limited rollout for pilot clients. Advanced features in shadow or read-only mode.",
    overrides: {
      "finance.fie": on("read_only"),
      "scheduling.intelligence": on("shadow"),
      "intelligence.dashboard": on("read_only"),
      "intelligence.automations": off(),
      "crm.lead_integrity": on("shadow"),
      "crm.follow_up": on("read_only"),
      "admin.friction_log": off(),
      "admin.system_audit": off(),
      "admin.control_plane": off(),
    },
  },
];
